import { ArrowLeft, CloseSquare, InfoCircle, More, SearchNormal1 } from "iconsax-react";
import { useEffect, useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { getToken } from "../../../../../utils/token";
import instance from "../../../../../axios/instance";
import timeAgo from "../../../../../utils/telemedicine/time_ago";
import { toast } from "react-toastify";

export default function WaitingRoom() {

   

    const [queueLoading, setQueueLoading] = useState(false)
    const [queueFromDb, setQueueFromDb] = useState([])

    const [reassignModal, setReassignModal] = useState(false)
    const [selectedMeeting, setSelectedMeeting] = useState(null)

    const [openModalId, setOpenModalId] = useState(null);

    const toggleModal = (id) => {
        setOpenModalId(prevId => (prevId === id ? null : id));
    };

    const navigate = useNavigate()

    async function getQueueFromDb() {
        setQueueLoading(true)
        instance.get("/telemedicine/doctor/meetings/queue", {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
        .then(response => {
            console.log(response.data);
            setQueueFromDb(response.data)
            setQueueLoading(false)
        })
        .catch(error => {
            console.log(error.response.data);
            setQueueFromDb([])
            setQueueLoading(false)
        })
    }

    useEffect(() => {
        getQueueFromDb()
    }, [])

    if (queueLoading) {
        return <div>fetching...</div>
        // change to loading component
    }
    
    return (
        <div className="p-3 space-y-6">
            <div className="flex items-center gap-2">
                <button onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} />    
                </button>
                
                <div className="font-medium text-[17px]">Queue Management</div>
            </div>


            <div className="border border-[#20232b22] shadow-sm">
                <div>
                    <div className="w-full flex items-center px-2">
                        <input className="flex-1 py-2 text-[14px] font-normal outline-none" placeholder="Search queue" />
                        <SearchNormal1 size={18} color="gray" />
                    </div>
                </div>
                <div className="grid grid-cols-12 gap-3 text-[12px] font-semibold w-full bg-[#20232b] text-white p-3">
                    <div className="col-span-3">Name</div>
                    <div className="col-span-3">Visit time</div>
                    <div className="col-span-3">Wait duration</div>
                    <div className="col-span-2">Meeting status</div>
                    <div className="col-span-1">Action</div> {/*rechedule and reassign*/}
                </div>

                {
                    selectedMeeting &&
                    <Reassign 
                        isOpen={reassignModal}
                        meeting={selectedMeeting}
                        onClose={() => {
                            setSelectedMeeting(null)
                            setReassignModal(false)
                        }}
                        onReassignComplete={data => {
                            //console.log("I was triggered");
                            
                            if (data) {
                                setSelectedMeeting(null)
                                setReassignModal(false)
                                window.location.reload()
                            }
                        }}
                    />
                }
               

                {
                    queueFromDb.length < 1 ?
                    <div className="p-3 text-[14px] text-gray-500">No patient in queue</div> :
                    queueFromDb.map(queue => (
                        <TableRow 
                            key={queue.id}
                            item={queue}
                            name={queue.patient_name}
                            createdAt={queue.created_at}
                            status={queue.meeting_status}
                            openModalId={openModalId}
                            toggleModal={() => toggleModal(queue.id)}
                            onReassign={() => {
                                setSelectedMeeting(queue)
                                setReassignModal(true)
                            }}
                            
                        />
                    ))
                }        
            </div>
        </div>
    )
}

function Reassign({ isOpen, onClose, meeting, onReassignComplete }) {

    const [onlineDoctors, setOnlineDoctors] = useState([])
    const user = useLoaderData()
    const [doctor, setDoctor] = useState(null)

    async function getOnlineDoctors() {
        instance.get("/doctor/get_online_doctors", {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
        .then(response => {
            console.log(response.data);
            setOnlineDoctors(response.data)
        })
        .catch(error => {
            setOnlineDoctors([])
            toast.error(error.response.data.message)
        })
    }

    async function reassignMeeting() {
        console.log(meeting.id);
        //console.log(doctor);
   
        
        
        
        instance.post("/doctor/reassign_meeting", {
            meeting_id: meeting.id,
            doctor_id: doctor
        }, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        })
        .then(response => {
            console.log(response.data);
            // setOnlineDoctors(response.data)
            toast.success(response.data.message)
            onReassignComplete(true)
        })
        .catch(error => {
            toast.error(error.response.data.message)
        })
    }

    useEffect(() => {
        getOnlineDoctors()
    }, [])

    return (
        <div className={`${isOpen ? "block" : "hidden"} fixed z-[1000] top-0 left-0 bottom-0 right-0 bg-[#11111122] flex justify-center items-center`}>
            <div className="bg-white rounded-[6px] w-[500px]">
                <div className="p-3 border-b flex justify-between items-center">
                    <div className="font-medium text-[14px]">Reassign patient</div>
                    <button onClick={onClose}>
                        <CloseSquare variant="Bold" size={20} />
                    </button>
                </div>

                <div className="px-3 py-2 flex gap-1 items-center">
                    <InfoCircle size={16} />
                    <div className="font-normal text-[14px]">Reassign <span className="font-medium">{meeting.patient_name}'s</span> meeting to another doctor</div>
                </div>


                <div className="px-3 text-[14px]">
                    <div>Active doctors: {onlineDoctors.length}</div>
                </div>
                <div className="p-3" onClick={getOnlineDoctors}>
                    <select onChange={e => setDoctor(e.target.value)} className="p-2 border w-full text-[14px] outline-[#00b0ad] rounded-[4px]">
                        <option value="">--Select active doctors--</option>
                        {
                            onlineDoctors.map(doctor => (
                                <option value={doctor.id} key={doctor.id}>{doctor.firstname} {doctor.lastname}</option>
                            ))
                        }
                    </select>

                </div>

                <div className="p-3">
                    <button onClick={reassignMeeting} className="bg-[#00b0ad] px-3 py-2 rounded-[4px] text-white font-medium text-[14px]">Reassign patient</button>    
                </div>
                
                
            </div>
        </div>
    )
}

function TableRow({ name, createdAt, status, openModalId, toggleModal, item, onReassign }) {


    const isOpen = openModalId === item.id;

    // Handler to close the modal and execute an action
    const handleAction = (action) => {
        toggleModal(null); // Close the modal after executing an action
        action(); // Execute the passed function (e.g., onView, onEdit)
    };

    return (
        <div className="grid grid-cols-12 gap-3 items-center text-[14px] font-normal w-full p-3 border-b">
            <div className="col-span-3 flex items-center gap-2">
                <div className="w-8 h-8 uppercase bg-[#00b0ad22] text-[#00b0ad] rounded-full text-[12px] font-medium flex justify-center items-center">
                    {name[0]}{name[name.length - 1]}
                </div>
                {name}
            </div>
            <div className="col-span-3">{new Date(createdAt).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            })}</div>
            <div className="col-span-3">{timeAgo(createdAt)}</div>
            <div className="col-span-2 capitalize font-semibold text-orange-500">{status}</div>
            <div className="col-span-1 flex justify-center items-center relative">
                <More onClick={() => toggleModal(item.id)} className="cursor-pointer" size={16} />

                <div className={`${isOpen ? "block" : "hidden"} z-50 shadow-md bg-white absolute top-4 right-4 border`}>
                    <div onClick={() => handleAction(onReassign)} className="px-4 cursor-pointer hover:bg-[#f1f1f1] py-2 whitespace-nowrap border-b">Reassign patient</div>
                    {/* <div className="px-4 cursor-pointer hover:bg-[#f1f1f1] py-2 whitespace-nowrap">Reschedule meeting</div> */}
                </div>
            </div>
        </div>
    )
}